import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "../utils/base_url";
import { clearCart } from "../redux/reducer/handleCart";
import toast from "react-hot-toast";
import { useAuth } from "./AuthContext";

export const PaymentContext = createContext();

const PaymentProvider = ({ children }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [pendingOrderId, setPendingOrderId] = useState(
        localStorage.getItem("pendingOrder")
    );
    const { user } = useAuth();
    const isAuthenticated = !!user;

    useEffect(() => {
        if (!pendingOrderId || !isAuthenticated) return;

        let stopped = false;    
        let attempts = 0;
        const MAX_ATTEMPTS = 12;

        const poll = async () => {
            if (stopped) return;

            if (++attempts > MAX_ATTEMPTS) {
                toast("Payment confirmation pending. Check orders later.");
                localStorage.removeItem("pendingOrder");
                setPendingOrderId(null);
                stopped = true;
                return;
            }

            try {
                const res = await api.get(`/payments/status/${pendingOrderId}/`);

                if (res.data.status === "success") {
                    dispatch(clearCart());
                    localStorage.removeItem("pendingOrder");
                    setPendingOrderId(null);
                    navigate(`/order-confirmation/${res.data.order_id}`);
                    // toast.success("order was placed successfully");
                    stopped = true;
                }
                if (["failed", "cancelled"].includes(res.data.status)) {
                    localStorage.removeItem("pendingOrder");
                    setPendingOrderId(null);
                    toast.error("Payment was not completed");
                    stopped = true;
                }
            } catch (error) {
                if (error.response?.status === 404) {
                    localStorage.removeItem("pendingOrder");
                    setPendingOrderId(null);
                    stopped = true;
                }
            }
        };

        poll();
        const interval = setInterval(poll, 3000);

        return () => {
            stopped = true;
            clearInterval(interval);
        };
    }, [pendingOrderId, isAuthenticated, dispatch, navigate]);

    return (
        <PaymentContext.Provider value={{ setPendingOrderId }}>
            {children}
        </PaymentContext.Provider>
    );
};

export default PaymentProvider;
